





















































import Vue from 'vue';
import axios from '@/plugins/axios';
import CtrlDialog from '@/components/common/control/CtrlDialog.vue';
// #897418 OutStatus対応
import CtrlMessageDialog from '@/components/common/control/CtrlMessageDialog.vue';
// #897418
import { mapGetters } from 'vuex';
import { API_SEARCH_MITSUMORI_HIMMOKU } from '@/constants/api';
import { BUTTON } from '@/constants/label';
// #897418 OutStatus対応
import { OutStatus } from '@/constants/constants';
// #897418

export default Vue.extend({
  name: 'ListMitsumorihimmoku',
  // #897418 OutStatus対応
  // components: { CtrlDialog },
  components: { CtrlDialog, CtrlMessageDialog },
  // #897418
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    getMitsumoruHimmoku: {
      type: Function,
    },
    kainaiKaigaiKb: {
      type: Number,
      required: true,
    },
    jigyoshoCd: {
      type: Number,
      required: true,
    },
    tokuisakiCd: {
      type: Number,
      required: true,
    },
    nohinsakiCd: {
      type: Number,
      required: true,
    },
    haisoKb: {
      type: Number,
      required: true,
    },
    gyoshuCd: {
      // #886575
      type: Number,
      default: 0,
    },
    initialDataSearch: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    BUTTON: BUTTON,
    headers: [
      {
        text: '',
        sortable: false,
        value: 'checked',
        width: 56,
      },
      {
        text: 'コード',
        sortable: true,
        value: 'aiteHimmokuCd',
        width: 101,
      },
      {
        text: '品目',
        sortable: true,
        value: 'himmokuRyakuMei',
        width: 500,
      },
      {
        text: 'ホクレン品目コード', // 0: 得意先品目コード, 1: ホクレン品目コード
        sortable: true,
        value: 'himmokuCd',
        width: 180,
      },
      {
        text: '見積備考',
        sortable: true,
        value: 'mitsumoriBiko',
        width: 350,
      },
    ],
    items: [],
    // #897418 OutStatus対応
    wMessage: false,
    wMessageId: '',
    wMessageTextParam: [] as string[],
    // #897418
  }),
  computed: {
    ...mapGetters({
      userInfo: 'common/userInfo',
    }),
  },
  methods: {
    // #897418 OutStatus対応
    // response error の場合の message dialog で OK click
    handleWarnExit() {
      this.wMessage = false;
      this.wMessageId = '';
      this.wMessageTextParam = [];
    },
    // #897418
    callbackOk() {
      const checkedItems = this.items.filter(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (item: any) => item.checked === true
      );
      if (checkedItems.length > 0) {
        this.getMitsumoruHimmoku(checkedItems);
        this.$emit('update:show', false);
      } else {
        this.wMessage = true;
        this.wMessageId = 'KI_W105';
        this.wMessageTextParam = [];
      }
    },
  },

  created() {
    const { kainaiKaigaiKb } = this.userInfo;
    if (kainaiKaigaiKb) {
      this.headers = this.headers.map((header) => {
        if (header.value === 'aitehimmokuCd') {
          return { ...header, text: 'ホクレン品目コード' };
        }
        return header;
      });
    }
    const params: any = {
      kainaiKaigaiKb,
      tokuisakiCd: this.tokuisakiCd,
      nohinsakiCd: this.nohinsakiCd,
      jigyoshoCd: this.jigyoshoCd,
      haisoKb: this.haisoKb,
    };

    // #886575
    if (this.gyoshuCd !== 0 && this.gyoshuCd !== undefined) {
      params.gyoshuCd = this.gyoshuCd;
    }

    this.initialDataSearch &&
      axios.get(API_SEARCH_MITSUMORI_HIMMOKU, { params }).then((res) => {
        // #897418 OutStatus対応
        if (
          res &&
          res.status == 200 &&
          res.data &&
          res.data.error &&
          res.data.error.outStatus &&
          res.data.error.outStatus != OutStatus.NORMAL
        ) {
          this.wMessageId = res.data.error.messageID;
          this.wMessageTextParam = res.data.error.messageArgs;
          this.wMessage = true;

          // 一覧をクリア
          this.items = [];
          return;
        }
        // #897418
        this.items = res.data.responseData;
      });
  },
});
